import { render, staticRenderFns } from "./BigSlide.vue?vue&type=template&id=3e93f300&"
import script from "./BigSlide.vue?vue&type=script&lang=js&"
export * from "./BigSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e93f300')) {
      api.createRecord('3e93f300', component.options)
    } else {
      api.reload('3e93f300', component.options)
    }
    module.hot.accept("./BigSlide.vue?vue&type=template&id=3e93f300&", function () {
      api.rerender('3e93f300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/BigSlide.vue"
export default component.exports